<template src="./institutionsPreliminaryModal.html"></template>

<script>
import dmModalMixin from '../../../../dmFramework/dmJS/dmModalMixin';
import institutionsEndpoints from '../institutions.endpoints';

export default {
    name: 'institutions-preliminary-modal',
    mixins: [dmModalMixin],
    data() {
        return {
            autoCompleteValueTimer: null,
            institutionOptions: [],
            institutionFields: {
                text: 'Name',
            },
            selectedInstitution: null,
        }
    },
    computed: {
        lblTitle() {
            if (this.selectedInstitution && this.selectedInstitution.InstitutionID > 0) {
                return 'Edit ' + this.selectedInstitution.Name;
            }

            return 'Add New Institution';
        },
        buttonText() {
            if (this.selectedInstitution && this.selectedInstitution.InstitutionID > 0) {
                return 'Continue to Edit';
            }

            return 'Continue to Add';
        },
    },
    methods: {
        btnContinueOnClick() {
            if (this.selectedInstitution && this.selectedInstitution.InstitutionID > 0) {
                let modalData = {
                    mode: 'edit',
                    dto: {},
                    callback: this.modalData.callback,
                }

                institutionsEndpoints.getByID(this.selectedInstitution.InstitutionID)
                    .then((response) => {
                        modalData.dto = response
                   
                        this.closePreliminaryModal()
                            .then(() => {
                                DMUtils.openApplicationModal('institutionsEditModal', modalData);
                            });
                    })
            } else {
                let institutionName = '';
                if (this.selectedInstitution) {
                    institutionName = this.selectedInstitution.Name;
                }

                let modalData = {
                    mode: 'add',
                    dto: {
                        Name: institutionName,
                        DegreeTypeCode: null,
                        FundingTypeCode: null,
                        StateCodeID: null,
                        IsActive: true,
                        SystemIDs: [],
                        PrimaryIntermediaryID: null,
                        AdditionalIntermediaryIDs: []
                    },
                    callback: this.modalData.callback,
                }

                this.closePreliminaryModal()
                    .then(() => {
                        DMUtils.openApplicationModal('institutionsEditModal', modalData);
                    });
            }
        },
        btnCancelOnClick() {
            this.closeModal();
        },
        autoCompleteInstitutionName(e) {
            e.preventDefaultAction = true;

            if (e.text === '') {
                this.institutionOptions = [];
                return;
            }

            if (this.autoCompleteValueTimer) {
                clearTimeout(this.autoCompleteValueTimer);
            }

            this.autoCompleteValueTimer = setTimeout(() => {
                institutionsEndpoints.autoComplete(e.text)
                    .then((response) => {
                        this.institutionOptions = response;
                        this.$refs.institutionAutocomplete.showPopup();
                    })
            }, 1000);     
        },
        getInstitution(args) {
            if (!args.itemData) {
                this.selectedInstitution = null;
                return;
            }

            this.selectedInstitution = args.itemData;
        },
        closePreliminaryModal() {
            return new Promise((resolve) => {
                this.$store.commit('ModalModule/closeModal', this.modalID);

                return resolve();
            })
        },
    },
}
</script>